
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuMicasadecoMenuMicasadecoMenuTopImage } from "@src/constants/images";
import { meta as pancakePageMeta } from "./pancake.mdx";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
export const meta = {
  path: "/media/harajuku/micasadeco_menu",
  title: "【全メニュー】ミカサデコカフェのパンケーキメニューを写真付きで公開！",
  description: "ミカサデコカフェ(MICASADECO & CAFE)のパンケーキのメニューを全て写真・値段付きでご紹介させていただきます！原宿・表参道・神宮前エリアでパンケーキ店として若い女性やカップルから大人気なお店ですが、インスタの写真だと値段がわからなかったりすることも多いと思うので、それを解消するための記事になっています。",
  topImg: harajukuMicasadecoMenuMicasadecoMenuTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "メニュー詳細", "デート", "女子会", "スイーツ", "インスタ映え", "パンケーキ", "穴場", "裏原"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ミカサデコカフェ(MICASADECO & CAFE)のパンケーキのメニューを全て写真・値段付きでご紹介させていただきます！`}</p>
    <p>{`原宿・表参道・神宮前エリアでパンケーキ店として若い女性やカップルから大人気なお店ですが、インスタの写真だと値段がわからなかったりすることも多いと思います。`}</p>
    <p>{`また、コロナなどで外出ができない、自宅で食べたいなどのニーズに合わせてテイクアウト・デリバリーメニューについてもご紹介させていただきます！`}</p>
    <h2>{`ミカサデコカフェとは？`}</h2>
    <p>{`東京、大阪、京都に３店舗を構えるパンケーキの人気店で、2020 年 3 月に東京の店舗が神宮前に移転し、リニューアルオープンしたお店です！`}</p>
    <p>{`大人が楽しめるカフェをコンセプトに、1 番人気のパンケーキだけでなく、月替りのランチメニューなど、素材にこだわった食事が食べられるお店として人気上昇中です！`}</p>
    <h2>{`【1 番人気】ふわふわリコッタチーズパンケーキ`}</h2>
    <InstaImage postId="B4txPmqg4E3" mdxType="InstaImage" />
    <h3>{`値段：1,350 円`}</h3>
    <p>{`インスタ映え間違いなし！
ミカサデコカフェ(MICASADECO&CAFE)の 1 番人気のメニューになります。`}</p>
    <p>{`注文を受けてから一枚一枚丁寧に焼き上げるパンケーキは、驚くほどふわふわで、`}<strong parentName="p">{`踊るパンケーキ`}</strong>{`と言われていることで有名。定番のメニューが食べたいという方は、こちらのメニューを選んでください。`}</p>
    <h2>{`【素材の味】リンゴのコンポートパンケーキ`}</h2>
    <InstaImage postId="B_kA2n5AMS7" mdxType="InstaImage" />
    <h3>{`値段：1,210 円`}</h3>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)は素材へのこだわりに自信があることでも有名！ このメニューは、パンケーキ甘みとリンゴの旨味がしっかり凝縮された一品になっています。`}</p>
    <p>{`パンケーキ生地だけでなく、素材本来の味を楽しみたい方はこちらのメニューがおすすめです！`}</p>
    <h2>{`【もちもち】もちもちプレーンパンケーキ`}</h2>
    <InstaImage postId="B90ODlEAuV1" mdxType="InstaImage" />
    <h3>{`値段：930 円`}</h3>
    <p><strong parentName="p">{`ふわふわなパンケーキ`}</strong>{`だけでなく、しっかりと食感を楽しめるパンケーキもあります。`}</p>
    <p>{`テイクアウトで 1 番人気のクラシックなパンケーキ。`}</p>
    <p>{`ふわっとした食感の後に、しっかり`}<strong parentName="p">{`もちもち`}</strong>{`した食感が楽しめる一品。
デコレーションも可愛く、シンプルでもインスタ映えするメニューになっています。`}</p>
    <h2>{`【和風】抹茶風もち入りパンケーキ`}</h2>
    <InstaImage postId="B-HDrCWjKNa" mdxType="InstaImage" />
    <h3>{`値段：1,320 円`}</h3>
    <p><strong parentName="p">{`抹茶が生地に練り込まれた`}</strong>{`もちもちのパンケーキになります！`}</p>
    <p>{`京都だと抹茶のふわふわパンケーキが食べられますが、そのパンケーキに近いものになります。
抹茶のほろ苦さとパンケーキの甘さが楽しめるメニューです。`}</p>
    <h2>{`【ハワイアン】ココナッツカスタードパンケーキ`}</h2>
    <InstaImage postId="B-uy6tOgstL" mdxType="InstaImage" />
    <h3>{`値段：1,260 円`}</h3>
    <p>{`クラシックなもちもちプレーンパンケーキに、カスタードとココナッツがトッピングされた、ハワイアンなパンケーキ。
ココナッツだけ、カスタードだけ、パンケーキと一緒に食べるなど、いろんな味が楽しめる一品になっています。
ハワイアンなパンケーキが好きな方は、こちらのメニューを選んで見てください！`}</p>
    <h2>{`【甘党】きなこのくるみパンケーキ`}</h2>
    <InstaImage postId="BYvOAIxhdtI" mdxType="InstaImage" />
    <h3>{`値段：1,320 円`}</h3>
    <p>{`クラシックなもちもとプレーンパンケーキに、たっぷりの`}<strong parentName="p">{`きなこ`}</strong>{`と`}<strong parentName="p">{`カリッとしたくるみ`}</strong>{`がトッピングされたメニュー。`}</p>
    <p>{`160 円を追加すると、`}<strong parentName="p">{`きなこ黒豆アイス`}</strong>{`をトッピングできるようになっており、甘党にはたまらない一品。
和風な甘みと食感を楽しみたい方は、こちらのメニューがオススメです！`}</p>
    <h2>{`トッピング`}</h2>
    <h3>{`シャンティー(プレーン/チョコ)`}</h3>
    <InstaImage postId="BzMqbU8gi0l" mdxType="InstaImage" />
    <h4>{`値段：160 円`}</h4>
    <p>{`チャンティーとはフランス語で、泡立てた生クリームのこと。
カスタードパンケーキに乗っているクリームの部分をイメージしていただければいいと思います。`}</p>
    <p>{`プレーンとチョコレートから選ぶことができるので、お好みで選んでください！`}</p>
    <h3>{`アイスクリーム(ミルク/チョコ/抹茶）`}</h3>
    <InstaImage postId="B-O_QBPFOWM" mdxType="InstaImage" />
    <h4>{`値段：270 円`}</h4>
    <p>{`写真のようにパンケーキにアイスクリームがトッピングできます！
1 つ 270 円と少し値段はお高めですが、せっかくパンケーキを食べにきたからこそ、ひやっとしたアイスクリームと温かいふわっとしたパンケーキを舌で味わって欲しいと思います。`}</p>
    <hr></hr>
    <h2>{`テイクアウト/デリバリーメニューも！`}</h2>
    <InstaImage postId="B_0_hengxBj" mdxType="InstaImage" />
    <p>{`コロナの影響もあり、テイクアウトと UberEats がスタートしました！`}</p>
    <p>{`行列ができている人気店なので、もし並ぶのが苦手な方、ご自宅で食べたい方はテイクアウトかデリバリーメニューを使ってみてください！`}</p>
    <h3>{`ブランチパンケーキセット(税込：1,300 円)`}</h3>
    <InstaImage postId="B_3030kA7EP" mdxType="InstaImage" />
    <p>{`その他にも通常メニューのテイクアウトもできます！`}</p>
    <h3>{`注文はお電話で！`}</h3>
    <p>{`事前に電話をして来店時間をお伝えしておけば、待たずに温かいパンケーキが受け取れると思います！`}</p>
    <p>{`ミカサデコ&カフェ 神宮前店：03-6803-8630`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`神宮前のキャットストリートに位置するお店で、神宮前から徒歩５分というアクセス！
休日はすごい行列ができているので、すぐに見つけることができると思います！`}</p>
    <GoogleMap lat={35.6665261} lng={139.7032377} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)にのパンケーキメニューに絞ってご紹介させていただきました！気になったメニューはありましたか？
もしミカサデコに足を運ぶ際には、メニューを確認して、食べたいパンケーキをじっくり選んでからお越しください！`}</p>
    <hr></hr>
    <p>{`関連記事`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;